import Immutable from 'immutable';
import { UPDATE_NAVIGATION_STATUS } from '../actions/navigationStatus';

const NAVIGATION = 'navigation';
const NAVIGATION_STATUS = 'navigationStatus';

export default function navigation(state = Immutable.Map(), action) {
    switch (action.type) {
        case UPDATE_NAVIGATION_STATUS:
            return state.setIn([NAVIGATION_STATUS], action.payload);
        default:
            return state;
    }
}

export const navigationStatusSelector = (state) => state.getIn([NAVIGATION, NAVIGATION_STATUS]);
